var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"user":_vm.user}}),_c('b-container',[_c('router-view',{staticClass:"main",attrs:{"user":_vm.user}})],1),_c('Footer',{attrs:{"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }